import React, { useState } from 'react'
import { Stack, TableContainer, Table, Tr, Th, Td } from '@chakra-ui/react'

import _ from 'lodash';
export default function SubscriptionDetails() {
    const [details] = useState({
        "Account Subscription": {
            "Subscription Status":"Active",
            "Current Plan":"Premium"
        },
        "Last Invoice Details": {
            "Invoice Number": "20747",
            "Invoice Status": "Paid",
            "Invoice Date": "25-Jul-2023",
            "Renewal Date": "25-Aug-2023",
            "Billed Amount": "GBP 189.00",
        },
        "Credits": {
            "Credits Purchased": "1,800",
            "Credits adjustment": "0",
            "Credits Brought Forward": "10,800",
            "Invoice Credits (0 docs x 1 credit per doc)": "0",
            "Statements Credits (0 pages x 3 credits per page)": "0",
            "Other Document Credits (0 pages x 2 credits per page)": "0",
        },
        "Credits Balance": "12,600"
    });

  return (
      <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
          <TableContainer h={'sm'} overflowY={'scroll'}>
              <Table size='sm'>
                  {
                      Object.entries(details).map(([key, value]) => (
                          _.isString(value) ? (
                              <Tr>
                                  <Th>{key}</Th>
                                  <Td>{value}</Td>
                              </Tr>
                          ) : (<>
                              <Tr><Th>{key}</Th></Tr>
                              <Tr>
                                  {
                                    Object.entries(value).map(([key, value]) => (<Tr><Td>{key}</Td><Td>{value}</Td></Tr>))
                                  }
                              </Tr>
                              </>
                          )
                      ))
                  }
              </Table>
          </TableContainer>
      </Stack>
  )
}
